module.exports = __webpack_public_path__ + "static/media/reglamento_3.018ba888.png";